import SelectWeekday from "@/views/crud/modules/SelectWeekday";
import SelectDate from "@/views/crud/modules/SelectDate";
import SelectOpeningHour from "@/views/crud/modules/SelectOpeningHour";
import timepicker from "@/views/crud/modules/timepicker";

export default {
  key: "opening_hour",
  id: "opening_hour_id",
  export: [],
  excel: {
     //max_row: "50000" 
  },
  sort_fields: [
    "opening_hour_id",
    "name",
    "start_time",
    "end_time",
    "weekday",
    "date_list",
    "cre_dttm",
    "lupd_dttm"
  ],
  filters: {
    opening_hour_id: {},
    name: {},
    start_time: {},
    end_time: {},
    // weekday: {},
    // date_list: {},
  },
  fields: [
    { key: "opening_hour_id", width: 75 },
    { key: "name" },
    { key: "start_time", type:"componentColumn", component:timepicker },
    { key: "end_time", type:"componentColumn", component:timepicker },
    { key: "weekday", type:"componentColumn", component:SelectWeekday, option:[{id:"1",name:"weekday.1"},{id:"2",name:"weekday.2"},{id:"3",name:"weekday.3"},{id:"4",name:"weekday.4"},{id:"5",name:"weekday.5"},{id:"6",name:"weekday.6"},{id:"7",name:"weekday.7"}] },
    // { key: "date_list", type:"componentColumn", component:SelectDate },
    { key: "cre_dttm", type: "datetime" },
    { key: "lupd_dttm", type: "datetime" },
    { type: "action-btn", width: 110 }
  ],
  structure: [
    ["name"],
    ["start_time","end_time"],
    ["weekday"],
    ["date_list"]
  ],
  action: ["create","edit", "view", "delete"],
  // default: {
  //   max_power_output: "32",
  //   heartbeat_interval: "30",
  //   enable_flag: 1
  // },
  view: [
    ["name"],
    ["start_time","end_time"],
    [{ key: "weekday", type:"componentColumn", component:SelectWeekday, option:[{id:"1",name:"weekday.1"},{id:"2",name:"weekday.2"},{id:"3",name:"weekday.3"},{id:"4",name:"weekday.4"},{id:"5",name:"weekday.5"},{id:"6",name:"weekday.6"},{id:"7",name:"weekday.7"}] }],
    // ["date_list"],
  ],
  extra_components: {
    view: [
      SelectOpeningHour
    ]
  }
}